import React, { createContext, useEffect, useState } from 'react';
import {createUserWithEmailAndPassword, getAuth, GithubAuthProvider, GoogleAuthProvider, onAuthStateChanged, sendEmailVerification, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile} from 'firebase/auth'
import app from '../../../firebase/firebase.config'

export const AuthContext = createContext();
const auth = getAuth(app);

const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const providerLogin = (provider) =>{
        setLoading(true);
        return signInWithPopup(auth, provider);
    }
    
   const googleProvider = new GoogleAuthProvider();
   const githubProvider = new GithubAuthProvider();


   const signInWithGoogle = () =>{
    setLoading(true);
    return signInWithPopup(auth, googleProvider)
   }
   const signInWithGithub = () => {
    setLoading(true);
    return signInWithPopup(auth, githubProvider)
   }
   

    const createUser = (email, password) => {
        setLoading(true);
        return createUserWithEmailAndPassword(auth, email, password)
    }

    const signIn = (email, password) => {
        setLoading(true);
        return signInWithEmailAndPassword(auth, email, password)
    }

    const updateUserProfile = (profile) =>{
        return updateProfile(auth.currentUser, profile)
    }

    const verifyEmail = () =>{
        return sendEmailVerification(auth.currentUser);
    }

    const logOut = () =>{
        setLoading(true);
        return signOut(auth);
    }

    useEffect(() =>{
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            console.log('inside auth state change', currentUser);
            if(currentUser === null || currentUser.emailVerified){
                setUser(currentUser);
            }
            setLoading(false);
        });

        return () => {
            unsubscribe()
        }
    }, [])

    const authInfo = { user, setUser, loading, setLoading, providerLogin, logOut, createUser, signIn,  updateUserProfile, verifyEmail, googleProvider, signInWithGoogle, signInWithGithub}

    return (
 
            <AuthContext.Provider value={ authInfo }>
                {children}
            </AuthContext.Provider>

    );
};

export default AuthProvider;